<div class="cell-renderer-index-name">
  @if (showInfoIcon) {
    <grid-ui-icon
      #indexInfoIcon
      (click)="clickInfoIcon()"
      data-hook="index-info-icon-span"
      class="cell-renderer-index-name__info-icon"
      name="info-circle"
      placement="top"
      [ngbTooltip]="'Show details'"
      data-testid="icon-index-info"
    ></grid-ui-icon>
  }

  <span data-hook="cell-renderer-index-name">{{ indexName }}</span>

  @if (updatedQuarter) {
    <span class="mc-updated-badge"> Updated {{ updatedQuarter }} </span>
  }
</div>
